<template lang="pug">
    header(:class="{white: popup==='mainPopup' || whiteHeader, hideLogo: !isMobileDevise && popup==='mainPopup'}")
        .logos
          a(href="https://www.rosatom.ru/en/" target="_blank" class="logo_rosatom")
          a(href="#" class="logo_rosatom75")
        nav(:class="{show:menuIsOpen}")
            router-link(to="/" data-hover exact active-class="active" @click.native="$store.commit('toggleMenu')") Main page
            router-link(:to="{path:'/', hash:'history'}" data-hover exact active-class="active" @click.native="$store.commit('toggleMenu')") History of Nuclear Industry
            a(href="https://calendar.atom75.com/" target="_blank" data-hover) CALENDAR OF CELEBRATIONS
            //a(href="#" data-hover) Международный фестиваль "WAW в Сочи"
            //a(href="#" data-hover) Лица Росатом
            //router-link.concurs(to="/contest" data-hover @click.native="$store.commit('toggleMenu')") Конкурс
            .socials
                a(href="https://www.facebook.com/rosatom.ru" data-hover target="_blank")
                    img.white(:src="require('@/assets/img/socials/fb_white.png')")
                    img.blue(:src="require('@/assets/img/socials/fb.png')")
                a(href="https://www.instagram.com/rosatom_ru/" data-hover target="_blank")
                    img.white(:src="require('@/assets/img/socials/inst_white.png')")
                    img.blue(:src="require('@/assets/img/socials/inst.png')")
                a(href="https://vk.com/rosatomru" data-hover target="_blank")
                    img.white(:src="require('@/assets/img/socials/vk_white.png')")
                    img.blue(:src="require('@/assets/img/socials/vk.png')")
                a(href="https://twitter.com/rosatom/" data-hover target="_blank")
                    img.white(:src="require('@/assets/img/socials/tw_white.png')")
                    img.blue(:src="require('@/assets/img/socials/tw.png')")
                a(href="https://www.youtube.com/user/MirnyAtom" data-hover target="_blank")
                    img.white(:src="require('@/assets/img/socials/yt_white.png')")
                    img.blue(:src="require('@/assets/img/socials/yt.png')")
            .lang
                a(href="https://atom75.ru/" data-hover v-html="'РУС'")
                a.red(href="https://atom75.com/" data-hover v-html="'&nbsp;&nbsp;/&nbsp;&nbsp;ENG'")
        .burger(@click="$store.commit('toggleMenu')" :class="{active:menuIsOpen, hide: hideBurger}")
            svg.ham.hamRotate.ham1.active(preserveAspectRatio="none" viewbox='0 0 100 100' width='80' onclick="this.classList.toggle('active')")
                path.line.line_top(d='m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40')
                path.line.line_middle(d='m 30,50 h 40')
                path.line.line_bottom(d='m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656')

</template>

<script>
    export default {
        name: "Header",
        computed:{
            popup(){return this.$store.state.popup},
            whiteHeader(){return this.$store.state.whiteHeader},
            menuIsOpen(){
                return this.$store.state.menuIsOpen
            },
            isMobileDevise(){
                return this.$store.state.isMobile
            },
            hideBurger(){
                return this.$store.state.hideBurger
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    header {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 87.7vw;
        margin: 0 auto;
        padding-top: 3vh;
        z-index: 100;
        pointer-events: none;

        .logos {
            .logo_rosatom {
              background: url(../../assets/img/rosatom_logo_split.png) no-repeat center center / contain;
              margin-right: 1rem;
            }
            .logo_rosatom75 {
              pointer-events: none;
              background: url(../../assets/img/rosatom75_logo_split.png) no-repeat center center / contain;
            }
            pointer-events: all;
            width: 10.5rem;
            height: 5.6rem;
            transition: .3s .2s;
            display: flex;
            a {
                display: block;
                width: 50%;
                height: 100%;
                transition: .3s;
            }
        }
        &.white{
            nav, .socials a img, .lang{
                transition: .3s .1s;
            }
            nav, .lang{
                color: #fff;
            }
            .socials a img{
                &.white{
                    opacity: 1;
                }
                &.blue{
                    opacity: 0;
                }
            }
            .burger path.line{
                stroke: #fff;
                transition: stroke-dasharray 400ms, stroke-dashoffset 400ms, stroke .3s .1s;
            }
            .logos {
              span, a {
                opacity: 0;
              }
            }
        }
        &.hideLogo{
            .logos{
                opacity: 0;
                pointer-events: none;
            }
        }
        nav, .socials a img, .lang{
            transition: .3s .5s;
        }
        nav {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 85%;
            margin-top: 1.4vh;
            color: $blue;
            pointer-events: all;

            & > a {
                position: relative;
                margin-left: 3.07vw;
                font-size: to_rem(14px);
                text-transform: uppercase;
                color: inherit;
                letter-spacing: 1.3px;
                &.active{
                    color: #fff;
                    &:before{
                        content: '';
                        display: block;
                        position: absolute;
                        top: -0.2rem;
                        left: -0.7rem;
                        right: -0.7rem;
                        bottom: -0.15rem;
                        z-index: -1;
                        transform: skewX(-10deg);
                        background: red;
                    }
                }
            }

            a.concurs {
                position: relative;
                margin: 0 0.8vw 0 2vw;
                padding: 0.6rem 4.3rem 0.6rem 3.8rem;
                color: #fff;
                letter-spacing: 1px;
                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: -22%;
                    z-index: -1;
                    background: url(../../assets/img/nav_concurs_bg.png) no-repeat center center / 100% 100%;
                }
            }
        }

        .socials {
            display: flex;
            margin-left: 3rem;
            a {
                position: relative;
                display: block;
                margin: 0 0.5rem;
                cursor: pointer;
                img.white{
                    opacity: 0;
                }
                img.blue{
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }
        }
        .lang{
            margin-left: 2rem;
            color: $blue;
            a{
                color: inherit;
            }
            .red{
                color: $red;
            }
        }
        .burger{
            display: none;
            position: fixed;
            top: 0vmin;
            right: 1vmin;
            pointer-events: all;
            svg{
                //height: 17vmin;
                //width: 18vmin;
                height: 8rem;
                width: 8rem;
                transition: transform 400ms;
                user-select: none;
            }

            path.line{
                stroke: $blue;
            }
            .line{
                fill: none;
                transition: stroke-dasharray 400ms, stroke-dashoffset 400ms, stroke .3s .3s;
                stroke: #fff;
                stroke-width: 5.5;
                stroke-linecap: round;
                &.line_top{
                    stroke-dasharray: 40 139;
                }
                &.line_middle{
                    stroke-dasharray: 40 180;
                }
                &.line_bottom{
                    stroke-dasharray: 40 139;
                }
            }
            &.active{
                svg{
                    transform: rotate(45deg);
                    path{
                        stroke: #fff;
                    }
                }
                .line.line_top{
                    stroke-dashoffset: -98px;
                }
                .line.line_bottom{
                    stroke-dashoffset: -138px;
                }
            }
            &.hide{
                opacity: 0;
                pointer-events: none;
            }
            @include razr530{
                top: -3vmin;
                right: -1vmin;
                &.active svg{
                    transform: rotate(45deg) scale(0.8);
                }
                svg{
                    transform: scale(0.8);
                }
            }
            @include razr360{
                top: -4vmin;
                right: -2vmin;
                &.active svg{
                    transform: rotate(45deg) scale(0.7);
                }
                svg{
                    transform: scale(0.7);
                }
            }
        }
    }
    .mobile header{
        &.white .logos a{
            opacity: 1;
        }
        .logos{
            position: fixed;
            top: 1%;
            left: 3.5%;
            z-index: 10000;
            width: 31vmin;
            height: 15vmin;
            .logo_rosatom {
              background: url(../../assets/img/rosatom_logo_split_mobile.png) no-repeat center center / contain;
              margin-right: 0;
            }
            .logo_rosatom75 {
              background: url(../../assets/img/rosatom75_logo_split_mobile.png) no-repeat center center / contain;
            }
            span, a{
                position: relative;
                z-index: 1;
            }
            &:before{
                content: '';
                display: block;
                position: absolute;
                top: -17vmin;
                left: -10vmin;
                right: -40vmin;
                bottom: 2vmin;
                transform: skewY(-21.6deg);
                background: #fff;
            }
        }
        nav{
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            width: 100vw;
            margin: 0;
            padding: 15vh 0 5vh;
            background: url(../../assets/img/menu_bg-mobile.jpg) no-repeat center center / 100% 100%;
            flex-direction: column;
            justify-content: space-around;
            font-family: Pobeda;
            font-weight: bold;
            transform: translate3d(-100%,0,0);
            opacity: 0;
            transition: .5s;
            &.show{
                transform: translate3d(0,0,0);
                opacity: 1;
            }
            a{
                color: #fff;
                font-size: 6.8vmin;
                &.concurs{
                    &:before{
                        display: none;
                    }
                }
            }
        }
        .socials{
            margin-left: 0;
            a{
                margin: 0 5vmin;
                transform: scale(1.2);
                img.white{
                    opacity: 1;
                }
                img.blue{
                    opacity: 0;
                }
            }
        }
        .burger{
            display: block;
        }
    }
</style>
